._Group_4f7x4_1 {
    display: flex;
    gap: 0.1em;
}
